import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { services } from "@/data/services";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-[#0F2117] text-[#F7F6F2] pt-20 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="lg:col-span-5">
            <Logo variant="light" />
            <p className="mt-6 text-sm text-white/60 max-w-sm leading-relaxed">
              Taranaki&rsquo;s quietly excellent solar installer. Designing,
              installing and connecting solar systems across New Plymouth
              and the surrounding region.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#F5C242]">Services</div>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    data-testid={`footer-service-${s.slug}`}
                    className="hover:text-white transition-colors"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#F5C242]">Coverage</div>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              {["New Plymouth", "Bell Block", "Waitara", "Inglewood", "Ōakura", "Stratford", "Hāwera", "Wider Taranaki"].map((l) => (
                <li key={l}>{l}</li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#F5C242]">Company</div>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              {[
                { l: "About", to: "/#about" },
                { l: "Process", to: "/#process" },
                { l: "FAQ", to: "/faq" },
                { l: "Quote", to: "/#quote" },
              ].map((c) => (
                <li key={c.l}>
                  <Link to={c.to} className="hover:text-white transition-colors">{c.l}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <div>© {year} Central Solar Ltd. Made in Aotearoa.</div>
          <div className="flex gap-6">
            <span>Privacy</span>
            <span>Terms</span>
            <span>Warranty</span>
          </div>
        </div>
      </div>

      <div
        aria-hidden
        className="font-display tracking-[-0.04em] text-[20vw] leading-none text-white/5 select-none whitespace-nowrap text-center mt-10"
      >
        CENTRAL · SOLAR
      </div>
    </footer>
  );
};

export default Footer;
